import { component } from "picoapp";

export default component((node) => {
  const buttons = node.querySelectorAll("[data-button]");
  const panels = node.querySelectorAll("[data-panel]");
  const state = [];

  buttons.forEach((button, index) => {
    button.addEventListener("click", (event) => {
      event.preventDefault();
      toggle(index);
    });

    if (button.dataset.initial) {
      state[index] = true;
    } else {
      state[index] = false;
    }
  });

  function toggle(index) {
    state[index] = !state[index];
    panels.forEach((panel, i) => {
      if (i === index && state[index]) {
        buttons[i].ariaExpanded = true;
        panel.style.display = "block";
      } else {
        buttons[i].ariaExpanded = false;
        panel.style.display = "none";
      }
    });
  }
});
